import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
// routes
import { PATH_PAGE } from '../routes/paths';

// config
import { HOST_API } from '../config';

// ----------------------------------------------------------------------
import { camelizeKeys, decamelizeKeys } from 'humps';
import { NavigateFunction } from "react-router";


const axiosInstance = axios.create({
  baseURL: HOST_API,
});

const excludedUrls = ['/api/auth'];

// Axios middleware to convert all api responses to camelCase

export const setupInterceptors = (navigate: NavigateFunction, logout: VoidFunction) => {

  axiosInstance.interceptors.response.use((response: AxiosResponse) => {
    if (
      response.data &&
      response.headers['content-type'] === 'application/json'
    ) {
      response.data = camelizeKeys(response.data);
    }

    return response;
  }, (error) => {
    if (error instanceof AxiosError) {
      let response: AxiosResponse = error.response as AxiosResponse;

      if (response.statusText === "UNAUTHORIZED" &&
        (response.config && response.config.url && excludedUrls.indexOf(response.config.url) === -1)) {
        logout();
        navigate(PATH_PAGE.page403, { replace: true });
      }

      return Promise.reject((response && response.data) || 'Something went wrong. Please try again later.')
    } else {
      return Promise.reject(error);
    }
  });

// Axios middleware to convert all api requests to snake_case
  axiosInstance.interceptors.request.use((config: AxiosRequestConfig) => {
    const newConfig = { ...config };

    if (newConfig.headers && newConfig.headers['Content-Type'] === 'multipart/form-data') {
      return newConfig;
    }

    if (config.params) {
      newConfig.params = decamelizeKeys(config.params);
    }
    if (config.data) {
      newConfig.data = decamelizeKeys(config.data);
    }
    return newConfig;
  });

  // axiosInstance.interceptors.response.use(
  //   (response) => response,
  //   (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
  // );
}

export default axiosInstance;
